// extracted by mini-css-extract-plugin
export default {"box":"RouterDeleteBlock_box","text":"RouterDeleteBlock_text","button":"RouterDeleteBlock_button"};